var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteAlt71(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM8.29226 16.9075C9.48981 16.1087 11.1756 14.476 11.1756 11.9182V9.28571C11.1756 8.57563 10.5488 8 9.77556 8H6.4C5.6268 8 5 8.57563 5 9.28571V13.1903C5 13.9003 5.6268 14.476 6.4 14.476H7.70865L7.54413 16.3857C7.48515 16.8392 7.90048 17.1688 8.29226 16.9075ZM16.1167 16.9075C17.3143 16.1087 19 14.476 19 11.9182V9.28571C19 8.57563 18.3732 8 17.6 8H14.2244C13.4512 8 12.8244 8.57563 12.8244 9.28571V13.1903C12.8244 13.9003 13.4512 14.476 14.2244 14.476H15.5331L15.3686 16.3857C15.3096 16.8392 15.7249 17.1688 16.1167 16.9075Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteAlt71);
export default __webpack_public_path__ + "static/media/quote-alt-7-1.b03f4d8e7fd3ece598b7169a1fb389f3.svg";
export { ForwardRef as ReactComponent };